import React from 'react';
import { useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  IconButton,
  Tooltip,
} from '@material-ui/core';
import * as actions from '../../../state';
import styles from './styles.module.css';

const messages = defineMessages({
  NEW_CARD: {
    id: 'NEW_CARD',
    defaultMessage: 'New card',
  },
  NEW_HEADER: {
    id: 'NEW_HEADER',
    defaultMessage: 'New header',
  },
  EDIT_CARD: {
    id: 'EDIT_CARD',
    defaultMessage: 'Edit card',
  },
  DATA_SETTINGS: {
    id: 'DATA_SETTINGS',
    defaultMessage: 'Data settings',
  },
  CHOOSE_DATA: {
    id: 'CHOOSE_DATA',
    defaultMessage: 'Choose Data',
  },
  CARD_CANCEL: {
    id: 'CARD_CANCEL',
    defaultMessage: 'Go back',
  },
  SETTINGS_BACK: {
    id: 'SETTINGS_BACK',
    defaultMessage: 'Go back without applying changes to settings',
  },
  ADD_DATA_SET: {
    id: 'ADD_DATA_SET',
    defaultMessage: 'Add a data set',
  },
  CONFIGURE_ALERT: {
    id: 'CONFIGURE_ALERT',
    defaultMessage: 'Configure Alert',
  },
});

const StepHeader = ({
  backAction,
  cancelChart,
  tabContent,
}) => {
  const selectedChart = useSelector(actions.readStateSelectedChart);

  let headerMsg = <FormattedMessage {...messages.EDIT_CARD} />;

  if (selectedChart && selectedChart.new) {
    headerMsg = selectedChart.type === 'Header'
      ? <FormattedMessage {...messages.NEW_HEADER} />
      : <FormattedMessage {...messages.NEW_CARD} />;
  }

  if (tabContent === 'selectStat') { headerMsg = <FormattedMessage {...messages.CHOOSE_DATA} />; }

  if (tabContent === 'configureSource') { headerMsg = <FormattedMessage {...messages.DATA_SETTINGS} />; }

  if (tabContent === 'configureAlert') { headerMsg = <FormattedMessage {...messages.CONFIGURE_ALERT} />; }

  let headerAction = (
    <Tooltip disableFocusListener title={<FormattedMessage {...messages.CARD_CANCEL} />}>
      <IconButton onClick={cancelChart} className={styles.actionBtns}>
        <ArrowBackIcon />
      </IconButton>
    </Tooltip>
  );

  if (tabContent !== 'base') {
    headerAction = (
      <Tooltip disableFocusListener title={<FormattedMessage {...messages.SETTINGS_BACK} />}>
        <IconButton onClick={backAction} className={styles.actionBtns}>
          <ArrowBackIcon />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <div className={styles.controlsHeader}>
      { headerAction }
      { headerMsg }
    </div>
  );
};

export default StepHeader;
